export default __webpack_public_path__ + "static/media/complaint.448661f4.jpg";